(function () {
  var roots = document.querySelectorAll('[data-before-after]');

  if (!roots.length) return;

  var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
  };

  roots.forEach(function (root) {
    var range = root.querySelector('[data-before-after-range]');
    if (!range) return;

    var markInteracted = function () {
      root.classList.add('is-interacted');
    };

    var setPosition = function (value) {
      var numericValue = Number(value);
      var position = clamp(Number.isNaN(numericValue) ? 50 : numericValue, 0, 100);
      root.style.setProperty('--ba-position', position + '%');
      range.setAttribute('aria-valuenow', String(position));
    };

    setPosition(range.value);

    range.addEventListener('input', function (event) {
      markInteracted();
      setPosition(event.target.value);
    });

    range.addEventListener('change', function (event) {
      markInteracted();
      setPosition(event.target.value);
    });

    range.addEventListener('pointerdown', markInteracted);
    range.addEventListener('keydown', markInteracted);
  });
})();
